import React, { useState } from "react";
import jpgIcon from "../../../assets/jpg_icon.png";

import { Checkbox, Text, Divider, Modal, Button, Pill } from "@mantine/core";
import "./CheckListMobileView.scss";

interface CheckListMobileViewProps {
  documents: any[];
  showTitle?: boolean;
  responses: any;
  hasSpouseDocs: boolean;
}

const CheckListMobileView: React.FC<CheckListMobileViewProps> = ({
  documents,
  showTitle,
  responses,
  hasSpouseDocs,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Calculate completed document types
  const totalCompletedTypes = documents.reduce((acc, doc) => {
    const uploadedCount = responses?.uploadedDocs?.[doc.type]?.length || 0;
    return acc + (uploadedCount >= doc.count ? 1 : 0);
  }, 0);

  return (
    <div className="mobile-view">
      {showTitle && (
        <div className="mobile-header">
          <Pill bg={"#D7F7DC"} c="#176E26" size="lg">
            {totalCompletedTypes}/{documents.length} Document Types Uploaded
          </Pill>
        </div>
      )}

      <Button
        variant="outline"
        onClick={() => setModalOpen(true)}
        style={{ marginTop: "1rem" }}
        radius={"md"}
      >
        Document Checklist
      </Button>

      <Modal
        opened={modalOpen}
        onClose={() => setModalOpen(false)}
        title={<Text fw={700}>Document Checklist</Text>}
        centered
      >
        <div className="mobile-document-list">
          <Text className="document-description" mb={"md"}>
            Based on your selections, you will need the following documents to
            file your taxes:
          </Text>
          {hasSpouseDocs
            ? ["My", "My Spouse's"].map((section, index) => (
                <div key={section} className="mobile-section">
                  {index > 0 && <Divider className="mobile-divider" />}
                  <Text fw={600} className="mobile-section-title">
                    {section} Documents
                  </Text>
                  {documents
                    .filter((doc) =>
                      section === "My"
                        ? !doc.type.includes("spouse")
                        : doc.type.includes("spouse")
                    )
                    .map((doc) => (
                      <div className="mobile-document-item" key={doc.type}>
                        <Checkbox
                          size="md"
                          radius="lg"
                          checked={
                            responses?.uploadedDocs?.[doc.type]?.length >=
                            doc.count
                          }
                          color="#0077CC"
                          readOnly
                        />
                        <div className="mobile-document-content">
                          <img
                            className="mobile-document-icon"
                            src={jpgIcon}
                            alt="Document icon"
                          />
                          <div className="mobile-document-info">
                            <Text fw={500} className="mobile-document-title">
                              {doc.title}
                              {doc.count > 1 && (
                                <span className="mobile-count-badge">
                                  {`${
                                    responses?.uploadedDocs?.[doc.type]
                                      ?.length ?? 0
                                  }/${doc.count}`}
                                </span>
                              )}
                            </Text>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ))
            : documents.map((doc) => (
                <div className="mobile-document-item" key={doc.type}>
                  <Checkbox
                    size="md"
                    radius="lg"
                    checked={
                      responses?.uploadedDocs?.[doc.type]?.length >= doc.count
                    }
                    color="#0077CC"
                    readOnly
                  />
                  <div className="mobile-document-content">
                    <img
                      className="mobile-document-icon"
                      src={jpgIcon}
                      alt="Document icon"
                    />
                    <div className="mobile-document-info">
                      <Text fw={500} className="mobile-document-title">
                        {doc.title}
                        {doc.count > 1 && (
                          <span className="mobile-count-badge">
                            {`${
                              responses?.uploadedDocs?.[doc.type]?.length ?? 0
                            }/${doc.count}`}
                          </span>
                        )}
                      </Text>
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </Modal>
    </div>
  );
};

export default CheckListMobileView;
